import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCertificateStar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-certificate-star';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 11.961c0 6.142.01 7.725.05 7.737.027.009 1.774.025 3.88.036l3.83.021V18.24H8.81c-1.205 0-2.608-.012-3.12-.026l-.93-.027V5.76h13.48V12h1.52V4.24H3.24zm4.258-3.67c-.011.029-.015.366-.009.75l.011.699 4.03.01 4.03.01V8.24h-4.021c-3.239 0-4.025.01-4.041.051m0 3c-.011.029-.015.366-.009.75l.011.699h8v-1.48l-3.991-.01c-3.229-.008-3.995-.001-4.011.041m8.511 2.303-.931 1.51-1.749.393c-.962.216-1.761.404-1.775.418s.512.628 1.168 1.365l1.194 1.34-.019.16c-.047.399-.299 3.352-.287 3.364.008.007.751-.292 1.652-.665s1.662-.679 1.691-.679.793.306 1.697.68 1.648.676 1.653.67c.006-.005-.06-.801-.146-1.767-.132-1.474-.148-1.767-.104-1.82l1.18-1.332c.62-.697 1.127-1.283 1.127-1.3s-.794-.212-1.765-.432l-1.766-.399-.905-1.469a67 67 0 0 0-.945-1.508c-.026-.026-.358.478-.97 1.471m1.42 2.098.449.733.828.187c.455.103.836.197.847.207.01.011-.109.164-.267.34l-.566.635-.28.314.077.856c.042.471.074.858.07.86a28 28 0 0 1-.821-.332l-.814-.337-.806.336c-.443.184-.811.325-.816.311-.006-.013.023-.401.064-.862l.075-.838-.482-.541-.576-.645-.094-.103.857-.194.857-.194.45-.732c.248-.403.461-.733.475-.733s.226.33.473.732"
    })
  }));
});
export default SvgCertificateStar;